// src/pages/Scan.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { QrReader } from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';

function Scan() {
  const navigate = useNavigate();
  const [scanResult, setScanResult] = useState(null);
  const [scanning, setScanning] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (scanResult) {
      try {
        const data = JSON.parse(scanResult);
        navigate('/payment-details', { state: { scannedData: data } });
      } catch (err) {
        console.error("Error parsing QR code data", err);
        setErrorMessage("Failed to parse QR code data. Please try again.");
      }
    }
  }, [scanResult, navigate]);

  const handleError = (error) => {
    console.error("QR Reader Error:", error);
    setErrorMessage("Error accessing the camera. Please ensure you have granted permissions and try again.");
  };

  return (
    <Box textAlign="center" position="relative">
      <Typography variant="h4" gutterBottom>
        Scan QR Code
      </Typography>
      <Box sx={{ width: 300, margin: '0 auto', position: 'relative' }}>
        <QrReader
          constraints={{ facingMode: "environment" }}
          onResult={(result, error) => {
            if (result) {
              console.log("QR Scan Result:", result?.text);
              setScanResult(result?.text);
              setScanning(false);
            }
            if (error) {
              console.error("onResult error:", error);
              // Optionally set error message if not already set in onError
              setErrorMessage("An error occurred while scanning. Please try again.");
            }
          }}
          onError={handleError}
          style={{ width: "100%" }}
        />
        {scanning && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            <CircularProgress color="inherit" />
            <Typography variant="body1" sx={{ mt: 1 }}>
              Scanning...
            </Typography>
          </Box>
        )}
      </Box>
      {errorMessage && (
        <Box mt={2}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}
    </Box>
  );
}

export default Scan;
